export const RECEIVE_REVIEWER_REVIEWS = 'RECEIVE_REVIEWER_REVIEWS'
export const RECEIVE_REVIEWEE_REVIEWS = 'RECEIVE_REVIEWEE_REVIEWS'
export const RECEIVE_REVIEW = 'RECEIVE_REVIEW'
export const DELETE_REVIEW = 'DELETE_REVIEW'
export const RECEIVE_REVIEWS_ERROR = 'RECEIVE_REVIEWS_ERROR'
export const CLEAR_REVIEWS = 'CLEAR_REVIEWS'
